/* Visual cues only: never split, move or duplicate article text. */
(()=>{
 const setup=root=>{
  if(root.dataset.mrpFlowReady)return;root.dataset.mrpFlowReady='true';
  const body=root.querySelector('[data-mrpca-article-body]'),copy=root.querySelector('[data-mrpca-portrait-copy]');
  if(!body)return;
  const host=body.closest('.mrpca__article');if(!host)return;
  const layer=document.createElement('div');layer.className='mrpca__continuation-layer';layer.setAttribute('aria-hidden','true');host.append(layer);
  const rectangles=node=>[...node.getClientRects()].filter(r=>r.width>30&&r.height>5);
  const paint=(from,to,portrait=false)=>{
   // Never place a departure at the article bottom, or two labels on the same line.
   const bodyBox=body.getBoundingClientRect();
   if(!portrait&&(from.bottom>=bodyBox.bottom-48||Math.abs((from.bottom+5)-(to.top-17))<30))return false;
   const box=host.getBoundingClientRect(),left=to.left<from.left;
   const start=document.createElement('span'),end=document.createElement('span');
   start.className=end.className='mrpca__continuation';start.textContent=left?'CONTINUED ↙':'CONTINUED ↘';end.textContent='↳ CONTINUED';
   start.style.left=`${from.left-box.left}px`;start.style.top=`${from.bottom-box.top+5}px`;
   end.style.left=`${to.left-box.left}px`;end.style.top=`${to.top-box.top-17}px`;layer.append(start,end);return true;
  };
  const update=()=>{
   layer.replaceChildren();if(!matchMedia('(min-width:990px)').matches)return;
   const width=body.getBoundingClientRect().width,first=[...body.children].find(x=>x.textContent.trim()&&!x.matches('figure,picture,video,iframe,table,.mrpca__publication-dates'));
   if(copy?.textContent.trim()&&first){
    const tail=[...copy.children].filter(x=>x.textContent.trim()&&!x.matches('.mrpca__publication-dates')).at(-1),from=tail&&rectangles(tail).at(-1),to=rectangles(first)[0];
    // Restore the portrait transition from 3305445; the two labels occupy different columns.
    if(from&&to&&Math.abs(from.left-to.left)>width*.2&&to.top>=from.top&&paint(from,to,true))return;
   }
   if(Number.parseInt(getComputedStyle(body).columnCount,10)<2)return;
   const media=[...body.querySelectorAll('img,video,iframe')].map(x=>x.getBoundingClientRect()).filter(r=>r.width>80&&r.height>80);
   if(!media.length)return;
   const segments=[...body.querySelectorAll('p,li')].filter(x=>x.textContent.trim().length>20&&!x.closest('blockquote,figcaption')&&!(x.tagName==='P'&&x.closest('li'))).flatMap(rectangles);
   let marked=false;
   for(let i=1;i<segments.length&&!marked;i++){
    const from=segments[i-1],to=segments[i];
    if(Math.abs(to.left-from.left)<width*.25||from.bottom-to.top<45)continue;
    // A normal column break has no cue; require a substantial image in that reading column.
    const ambiguous=media.some(m=>Math.abs(m.left-from.left)<width*.2&&m.top>=body.getBoundingClientRect().top&&m.bottom<=from.bottom);
    if(ambiguous&&paint(from,to))marked=true;
   }
  };
  let scheduled=false;const queue=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{scheduled=false;update();})));};
  const observer=new ResizeObserver(queue);observer.observe(body);if(copy)observer.observe(copy);
  root.closest('[id^="shopify-section-"]')?.addEventListener('mrpca:layout',queue);
  root.addEventListener('load',queue,true);window.addEventListener('resize',queue,{passive:true});document.fonts?.ready.then(queue);queue();
 };
 document.querySelectorAll('article.mrpca').forEach(setup);
})();

